import { FRAME_DELIVERY_POLICY } from '../policies/frameDelivery.policy.js';
const identity = new Set(['id', 'fixtureId', 'fixture_id', 'oddStateId', 'room', 'mode', 'scope', 'sport', 'filterHash', 'updatedAt']);
const prices = new Set(['odds', 'price', 'priceDecimal']);
const scores = new Set(['score', 'clock', 'scoreHome', 'scoreAway', 'score_home', 'score_away', 'live_score_home', 'live_score_away']);
const scalar = value => typeof value === 'number' && Number.isFinite(value)
  || typeof value === 'string' && value.length <= 256;
const record = value => value && !Array.isArray(value) && typeof value === 'object';
// Admission classifies only. Existing reducers own all display/domain decisions.
export function isFrameDisplayDelta(lane, envelope) {
  if (!['list', 'fixture'].includes(lane) || !record(envelope?.patch)) return false;
  let nodes = 0, changed = false;
  const leaf = (value, allowed, depth) => {
    if (++nodes > FRAME_DELIVERY_POLICY.maxShapeNodes || depth > FRAME_DELIVERY_POLICY.maxShapeDepth) return false;
    if (scalar(value)) return true;
    if (!record(value)) return false;
    const entries = Object.entries(value);
    return entries.length > 0 && entries.every(([key, v]) => allowed.has(key) && leaf(v, allowed, depth + 1));
  };
  const visit = (row, depth = 0) => {
    if (!record(row) || ++nodes > FRAME_DELIVERY_POLICY.maxShapeNodes || depth > FRAME_DELIVERY_POLICY.maxShapeDepth) return false;
    return Object.entries(row).every(([key, value]) => {
      if (identity.has(key)) return scalar(value);
      if (key === 'fields') {
        if (Array.isArray(value)) return value.length > 0 && value.every(name =>
          (prices.has(name) || scores.has(name) || name === 'mainOdds') && Object.hasOwn(row, name));
        return visit(value, depth + 1);
      }
      if (key === 'fixtures') {
        const rows = Array.isArray(value) ? value : record(value) ? Object.values(value) : [];
        return rows.length > 0 && rows.every(item => visit(item, depth + 1));
      }
      if (key === 'fixture') return visit(value, depth + 1);
      if (prices.has(key)) { changed = true; return scalar(value); }
      if (key === 'mainOdds') {
        changed = true;
        return leaf(value, new Set(['home','draw','away','id','oddStateId','price','priceDecimal','odds']), depth + 1);
      }
      if (scores.has(key)) {
        changed = true;
        return leaf(value, new Set(['home','away','minutes','seconds','elapsed']), depth + 1);
      }
      // includes status, period, locks, lifecycle, markets, ops and unknown future fields
      return false;
    });
  };
  return visit(envelope.patch) && changed;
}
